//#region src/components/SourceTabs/SourceTabs.module.css
var e = "_container_lcg5r_1", t = "_hint_lcg5r_8", n = "_tabs_lcg5r_16", r = "_titles_lcg5r_21", i = "_tabContent_lcg5r_29", a = {
	container: e,
	hint: t,
	tabs: n,
	titles: r,
	tabContent: i
};
//#endregion
export { e as container, a as default, t as hint, i as tabContent, n as tabs, r as titles };
